import { Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsTeaser } from '@fcom/core-api';

@Component({
  selector: 'cms-descriptive-link-list',
  templateUrl: './cms-descriptive-link-list.component.html',
  styleUrls: ['./cms-descriptive-link-list.component.scss'],
  standalone: false,
})
export class CmsDescriptiveLinkListComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input.required<CmsCollection>();

  items = computed((): CmsTeaser[] => {
    return (this.content()?.items ?? []) as CmsTeaser[];
  });
}
